import { computed } from '@vue/composition-api';
import { useCommonColumns } from '@/views/Brand/Applications/Offer/Details/composables/use-common-columns';
import { useAcceptanceColumns } from '@/views/Brand/Applications/Offer/Details/composables/use-acceptance-columns';
export const useReservationColumns = (ctx, offer, shownYear) => {
    const { commonColumns } = useCommonColumns(ctx, {
        offer,
        shownYear,
        useOfferObjectDetails: true,
    });
    const { acceptanceColumns } = useAcceptanceColumns(ctx, {
        offer,
        isReadOnlyAcceptance: true,
    });
    const columns = computed(() => {
        return [
            ...commonColumns.value,
            ...(offer.isApprovalRequired ? acceptanceColumns : []),
        ];
    });
    return { columns };
};
